import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScenarioManagementDashboard from './screens/ScenarioManagementDashboard';
import ScenarioEditor from './screens/ScenarioEditor';
import ScenarioLibrary from './screens/ScenarioLibrary';
import ScenarioPreview from './screens/ScenarioPreview';
import { ScenarioErrorBoundary } from '../../components/ui/ErrorBoundary';

/**
 * Scenario Management Routes
 * Defines all routes for the scenario management system
 */
export const ScenarioManagementRoutes: React.FC = () => {
  return (
    <ScenarioErrorBoundary>
      <Routes>
        {/* Main dashboard */}
        <Route path="/" element={<ScenarioManagementDashboard />} />
        
        {/* Scenario creation (uses editor with no ID) */}
        <Route path="/create" element={<ScenarioEditor />} />
        
        {/* Scenario editing */}
        <Route path="/edit/:scenarioId" element={<ScenarioEditor />} />
        
        {/* Scenario library */}
        <Route path="/library" element={<ScenarioLibrary />} />
        
        {/* Analytics dashboard */}
        
        {/* Preview mode */}
        <Route path="/preview/:scenarioId" element={<ScenarioPreview />} />
      </Routes>
    </ScenarioErrorBoundary>
  );
};

export default ScenarioManagementRoutes;